import { Box } from '@material-ui/core';
import { LocalActivity, Visibility } from '@material-ui/icons/';
import moment from 'moment';
import { config } from '../../config';
import { useConnect } from '../../context/connect';
import { useStyles } from './style';
import { getPrice } from '../../helpers/getPrice';

export const Iterable = () => {
  const classes = useStyles();
  const { contact } = useConnect();

  const attributeMap = contact?.getAttributes();

  if (
    attributeMap &&
    (!('IterableData' in attributeMap) || !attributeMap.IterableData?.value)
  )
    return null;
  const { orders, pages } =
    attributeMap && JSON.parse(attributeMap.IterableData?.value || '{}');

  return (
    <>
      {!!orders?.length && (
        <Box className={classes.profile} p={2} display={'flex'}>
          <Box mr={2}>
            <LocalActivity fontSize="small" style={{ color: '#4a4a4a' }} />
          </Box>
          <Box width={1}>
            <Box className={classes.title} mb={1}>
              Last purchases
            </Box>
            <Box>
              {orders.map((i: any) => (
                <Box
                  key={i.id}
                  display={'flex'}
                  width={1}
                  alignItems={'center'}
                  mb={0.5}
                >
                  <Box width={1}>
                    <Box display={'flex'} alignItems={'center'} width={1}>
                      <Box mr={1}>
                        <a
                          className={classes.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`${config.platformUrl}/orders/${i.id}`}
                        >
                          #{i.id}
                        </a>
                      </Box>
                      <Box mr={1} className={classes.title}>
                        Total Amount:
                      </Box>
                      {getPrice(i.total)}
                      <Box className={classes.date} ml={'auto'}>
                        <Box>
                          {moment(i.createdAt).format('HH:mm MM/DD/YY')}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
      {!!pages?.length && (
        <Box className={classes.profile} p={2} display={'flex'}>
          <Box mr={2}>
            <Visibility fontSize="small" style={{ color: '#4a4a4a' }} />
          </Box>
          <Box>
            <Box className={classes.title} mb={1}>
              Last visited pages
            </Box>
            <Box>
              {pages.map((i: any) => (
                <Box
                  key={i.createdAt}
                  display={'flex'}
                  width={1}
                  alignItems={'center'}
                  mb={0.5}
                >
                  <Box flex={1}>
                    <a
                      className={classes.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        i.dataFields?.path ? `${config.siteUrl}/${i.path}` : ''
                      }
                    >
                      {i.title}
                    </a>
                  </Box>
                  <Box className={classes.date} ml={2}>
                    {moment(i.createdAt).format('HH:mm MM/DD/YY')}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
